import RugCard from './RugCard'
export default RugCard
